var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn question-option-button",class:{'active': _vm.active === _vm.valueKey },attrs:{"role":"button"},on:{"click":function($event){return _vm.setActive()}}},[_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }